import { Component, Input } from '@angular/core';
import { BaseAccordionComponent } from '../base-accordion.component';

@Component({
  selector: 'app-visit-detail-instruction',
  templateUrl: './visit-detail-instruction.component.html',
  styleUrls: ['./visit-detail-instruction.component.scss'],
})
export class VisitDetailInstructionComponent extends BaseAccordionComponent {
  @Input() visit;
}
